import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4efe9150&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/data/websites/erp-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4efe9150')) {
      api.createRecord('4efe9150', component.options)
    } else {
      api.reload('4efe9150', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4efe9150&", function () {
      api.rerender('4efe9150', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/imgUpload/main.vue"
export default component.exports